import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { PolicySearchComponent } from './components/policy-search/policy-search.component';
import { PolicyFoundComponent } from './components/policy-found/policy-found.component';
import { PaymentComponent } from './components/payment/payment.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { ReviewPaymentDetailsComponent } from './components/review-payment-details/review-payment-details.component';
import { PaymentConfirmationComponent } from './components/payment-confirmation/payment-confirmation.component';
import { ViewPaymentDetailsComponent } from './components/view-payment-details/view-payment-details.component';
import { RecurringPaymentsComponent } from './components/recurring-payments/recurring-payments.component';
import { VersionComponent } from './components/version/version.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: LandingPageComponent },
  { path: 'policy-search', component: PolicySearchComponent },
  { path: 'policy-found', component: PolicyFoundComponent },
  { path: 'payment', component: PaymentComponent },
  { path: 'payment-method', component: PaymentMethodComponent },
  { path: 'review', component: ReviewPaymentDetailsComponent },
  { path: 'confirmation', component: PaymentConfirmationComponent },
  { path: 'view', component: ViewPaymentDetailsComponent },
  { path: 'recurring', component: RecurringPaymentsComponent },
  {
    path: 'release/version', component: VersionComponent,
    data: {
      bannerText: '',
      pageSectionHeaderText: ''
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
